import { Guid } from '@web/utils';

export class PublicCosmeticCharacteristic {
  public constructor(
    private readonly data: {
      content: string;
      id: Guid;
      label: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get label(): string {
    return this.data.label;
  }

  public get content(): string {
    return this.data.content;
  }
}
